import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const ButtonActionsGrid = styled.div<{ noDesktopFullWidth?: boolean }>`
  display: grid;

  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px;

  width: calc((100% - 7.5rem) / 2);

  @media ${BREAKPOINTS.XL.max} {
    ${(p) => ({ width: !p.noDesktopFullWidth ? '100%' : undefined })}
  }

  @media ${BREAKPOINTS.LG.max} {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`

export const ButtonActions = styled(ButtonActionsGrid)`
  padding-top: 2rem;
  margin-left: auto;
  z-index: 2;

  & > button {
    min-width: fit-content;
  }

  & > button:first-of-type:last-of-type {
    grid-column: 2;
  }

  @media ${BREAKPOINTS.MD.min} {
    position: sticky;
    padding: 0;
    bottom: var(--p-spacing);
    margin-top: var(--p-spacing);
    margin-left: auto;
  }
  @media ${BREAKPOINTS.MD.max} {
    position: fixed;
    bottom: 0;
    bottom: env(safe-area-inset-bottom, 0px);
    left: 0;
    right: 0;

    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);

    padding: 5vw;
    width: 100%;

    & button {
      width: 100%;
      flex-grow: 1;
    }
  }
`
